enum Role {
  MANAGER = "Gestionnaire",
  SUPER_ADMIN = "Super-administrateur",
  ADMIN = "Administrateur",
  CITY = "Ville",
  PLACER = "Placier",
  MERCHANT = "Commerçant",
  CUSTOMER_SERVICE = "Service-client",
  GUEST = "Invité",
  HEAD_OF_OPERATION = "Responsable exploitation",
  HEAD_OF_PLACERS = "Superviseur-placier",
  WORKER = "Ouvrier",
  AUDITOR = "Auditeur",
  ACCOUNTANT = "Comptable",
  MANAGER_PLACER = "Gestionnaire-placier",
  COM_RSE = "Service Com - RSE",
}
type RoleEntity = {
  id: number;
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
  permissions: PermissionEntity;
};
type RoleWithPermissions = {
  id: number;
  name: string;
  permissions?: BasicPermissionInfo[];
};
type BasicPermissionInfo = Pick<PermissionEntity, "id" | "name"> & {
  description?: string | null;
  group?: PermissionGroupInfo | null;
};
type PermissionEntity = {
  id: number;
  name: string;
  guard_name: string;
  group_id: number;
  created_at: string;
  updated_at: string;
};
type PermissionGroupInfo = {
  id: number;
  name: string;
};

/** Nature d'une permission — reflète l'enum backend `App\Domain\PermissionType`. */
type PermissionType = "CRUD" | "Métier" | "Référentiel" | "Page";

/**
 * Permission telle que renvoyée par l'API avec sa catégorie (`?include=group`).
 * `description` et `type` sont nullable en base : toujours prévoir le repli sur `name`.
 */
type PermissionWithGroup = {
  id: number;
  name: string;
  description?: string | null;
  type?: PermissionType | null;
  group_id?: number | null;
  group?: PermissionGroup | null;
};

type PermissionGroup = {
  id: number;
  name: string;
  order: number | null;
};

export type {
  PermissionGroup,
  PermissionGroupInfo,
  PermissionType,
  PermissionWithGroup,
  RoleWithPermissions,
  BasicPermissionInfo,
  RoleEntity,
};
export default Role;
